import { getIn, useFormikContext } from "formik";
import { FormControlLabel, Paper, Stack, Switch } from "@mui/material";
import Map, { INITIAL_LOCATION, MAPTYPE } from "@/components/map/Map";
import InputText from "@/components/InputText";
import { useAccessControl } from "@/features/access-control";
import { Branch } from "@/types/branch";
import { useEffect, useRef } from "react";

const GeneralView = () => {
    const { values, setFieldValue, errors, touched } = useFormikContext<Branch>();
    const { hasAccess } = useAccessControl();

    const mapRef = useRef<any>(null);
    const markerRef = useRef<any>(null);

    const loadMap = (map: any, maps: any) => {
        mapRef.current = map;

        const position = {
            lat: values.location.latitude ?? INITIAL_LOCATION.lat,
            lng: values.location.longitude ?? INITIAL_LOCATION.lng,
        };

        markerRef.current = new maps.Marker({
            position,
            map,
            draggable: true,
        });

        if (hasAccess("update.organization")) {
            markerRef.current.addListener("dragend", () => {
                const newLatitude = markerRef.current.getPosition().lat();
                const newLongitude = markerRef.current.getPosition().lng();
                setFieldValue("location.latitude", newLatitude);
                setFieldValue("location.longitude", newLongitude);
            });
        }
    };

    useEffect(() => {
        if (!markerRef.current || !mapRef.current) return;

        const newPosition = {
            lat: values.location.latitude ?? INITIAL_LOCATION.lat,
            lng: values.location.longitude ?? INITIAL_LOCATION.lng,
        };

        markerRef.current.setPosition(newPosition);
        mapRef.current.panTo(newPosition);
    }, [values.location.latitude, values.location.longitude]);

    return (
        <Stack spacing={2}>
            <Map
                key={values.id}
                height="350px"
                googleApiLoaded={({ map, maps }) => loadMap(map, maps)}
                type={MAPTYPE.ROADMAP}

            />
            <Stack p={2}>
                <Paper>
                    <Stack spacing={2} padding={2}>
                        <InputText
                            size="small"
                            label="Título"
                            name={"title"}
                            value={values.title ?? ""}
                            error={Boolean(getIn(touched, "title") && getIn(errors, "title"))}
                            helperText={Boolean(getIn(touched, "title") && getIn(errors, "title"))}
                            placeholder="Ingrese el título de la sucursal"
                        />

                        <InputText
                            size="small"
                            label="Whatsapp"
                            name={"whatsapp"}
                            value={values.whatsapp ?? ""}
                            error={Boolean(getIn(touched, "whatsapp") && getIn(errors, "whatsapp"))}
                            helperText={Boolean(getIn(touched, "whatsapp") && getIn(errors, "whatsapp"))}
                            placeholder="Ingrese el whatsapp de la sucursal"
                        />

                        <InputText name="location.address" label="Dirección" value={values.location.address ?? ""} />
                        <FormControlLabel
                            label={"Sucursal Principal"}
                            control={<Switch name="isMainBranch" checked={values.isMainBranch} />}
                            onChange={(e) => setFieldValue("isMainBranch", e.target.checked)}
                        />
                    </Stack>
                </Paper>
            </Stack>
        </Stack>
    )
}

export default GeneralView;
